import { render, staticRenderFns } from "./bosssoftTaskDetail.vue?vue&type=template&id=7d0146fb&scoped=true&"
import script from "./bosssoftTaskDetail.vue?vue&type=script&lang=tsx&"
export * from "./bosssoftTaskDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./bosssoftTaskDetail.vue?vue&type=style&index=0&id=7d0146fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0146fb",
  null
  
)

export default component.exports